import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Conta criada! A 1ª aula de cada curso é grátis.");
      nav("/cursos");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Algo deu errado");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="grid-bg min-h-[85vh] flex items-center px-4 py-16">
      <div className="max-w-md mx-auto w-full">
        <span className="sticker">FAZ TEU CADASTRO</span>
        <h1 className="font-bebas text-6xl mt-6 tracking-tighter">CRIA TUA CONTA</h1>
        <p className="text-white/60 mt-3 font-manrope">Cadastra rápido e desbloqueia teus cursos.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="register-name" required value={name} onChange={(e)=>setName(e.target.value)} placeholder="Teu nome" className="brutal-input"/>
          <input data-testid="register-email" required type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Email" className="brutal-input"/>
          <input data-testid="register-password" required type="password" minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="Senha (min 6)" className="brutal-input"/>
          <button data-testid="register-submit" disabled={loading} className="brutal-btn w-full">{loading? "Enviando..." : "Bora"}</button>
        </form>
        <p className="mt-6 text-white/60 font-manrope">
          Já tem conta? <Link data-testid="register-to-login" to="/login" className="text-[#CCFF00] underline">Entra aqui</Link>
        </p>
      </div>
    </div>
  );
}
